<template>
  <div id="dcDetail">
    <!-- 设备基本信息 -->
    <el-row>
      <!-- 流程图 -->
      <div class="paneDivWarp" style="padding-bottom: 45px;">
        <p class="flowP">
          {{ dcSn }}
          <span>{{ dcInfoTem.timeAgo }}</span>
        </p>
        <div class="flowDivWarp">
          <img v-if="dcInfoTem.curBy=='alt'" src="@/assets/images/kisae/flowChart/dcAltFlow.gif" alt="" style="width: 100%;">
          <img v-else-if="dcInfoTem.curBy=='pv'" src="@/assets/images/kisae/flowChart/dcPvFlow.gif" alt="" style="width: 100%;">
          <img v-else src="@/assets/images/kisae/flowChart/dcOfflineFlow.jpg" alt="" style="width: 100%;">
          <div class="altData flowDataDiv">
            <p>{{ dcInfoTem.altV }} V</p>
            <p>{{ dcInfoTem.altA }} A</p>
          </div>
          <div class="pvData flowDataDiv">
            <p>{{ dcInfoTem.pvV }} V</p>
            <p>{{ dcInfoTem.pvA }} A</p>
          </div>
          <div class="outData flowDataDiv">
            <p>{{ dcInfoTem.outV }} V</p>
            <p>{{ dcInfoTem.outA }} A</p>
          </div>
        </div>
      </div>
      <!-- 状态 -->
      <div class="paneDivWarp paneDivStatusWarp">
        <div class="divWarp25">
          <div class="paneDivStatusImg">
            <img v-if="!dcInfoTem.online" src="@/assets/images/kisae/chargeStage_offline.png" alt="">
            <img v-else-if="dcInfoTem.online&&dcInfoTem.status===0" src="@/assets/images/kisae/3-1.png" alt="">
            <img v-else-if="dcInfoTem.online&&dcInfoTem.status==1" src="@/assets/images/kisae/3-2.png" alt="">
            <img v-else-if="dcInfoTem.online&&dcInfoTem.status==2" src="@/assets/images/kisae/3-3.png" alt="">
            <img v-else src="@/assets/images/kisae/chargeStage_online.png" alt="">
          </div>
          <div class="paneDivStatusP">
            <p>STATUS</p>
            <p v-if="dcInfoTem.online&&dcInfoTem.status===0" class="statusP">Bulk</p>
            <p v-else-if="dcInfoTem.online&&dcInfoTem.status==1" class="statusP">ABS</p>
            <p v-else-if="dcInfoTem.online&&dcInfoTem.status==2" class="statusP">Float</p>
            <p v-else class="statusP">--</p>
          </div>
        </div>
      </div>
      <!-- 警告 -->
      <div class="paneDivWarp warningWarp">
        <el-table :data="warningList" style="width: 100%" :show-header="false" empty-text="The device has no warning for the time being.">
          <el-table-column width="100">
            <template slot-scope="scope">
              <img :src="scope.row.imgUrl" alt="" style="width: 80px;">
              <!-- <img src="@/assets/images/warningSimpleImg/E02.png" alt=""> -->
            </template>
          </el-table-column>
          <el-table-column prop="question">
            <template slot-scope="scope">
              <span>{{ scope.row.question }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="answer" />
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { updateTimeOnlyEn } from '@/utils/updateTime.js'

export default {
  name: '',
  components: {
  },
  props: {
    dcTabPaneInfo: {
      type: Object,
      default: () => { }
    },
    dcSn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dcInfoTem: {
        curBy: '--',
        altV: '--',
        altA: '--',
        pvV: '--',
        pvA: '--',
        outV: '--',
        outA: '--',
        timeAgoRes: null,
        timeAgo: null
      },
      warningList: [],
      warningdcInfo: [// dc警告文字
        { key: 'E01', id: 'bit4', question: 'CH3 High Input Voltage Shutdown', answer: 'This means the unit has detected the input from the Start/Alternator has gone above 16.0V on a 12V input or 32.0V on 24V input. This error will clear once the input has dropped below 15.5V on a 12V input or 31.0V on a 24V input.' },
        { key: 'E02', id: '', question: 'CH3 Low Input Voltage Shutdown', answer: 'This means the unit has detected that the input from the Start/Alternator has gone below 10.5V on a 12V input 21.0V on a 24V input. This error will clear once the input has risen above 13.2V on a 12V input or 26.4V on a 24V input.If you have this error:• Check that the voltage of your Start Battery is above 13.2V on a 12V input or 26.4V on a 24V input. • Check that you have not left the “Priority” (Override) feature activated (Manual or Auto) • Check that the battery cable from the Start Battery is correctly sized. • Check you don’t have a loose terminal or blown fuse.' },
        { key: 'E03', id: 'bit2', question: 'CH2 High Input Voltage Shutdown', answer: 'This means the unit has detected the input from the solar has gone above 45.0V. This error will clear once the input has dropped below 44.0V.If you have this error:• Check the specification of your panels – the Volts Open Circuit (VOC) should not exceed 45VOC• Make sure the solar panels have not been connected in series as this will increase the VOC voltage of the panel array.Please Note: Maximum solar VOC input must not exceed 45VOC or damage to the unit will occur.' },
        { key: 'E04', id: 'bit3', question: 'CH2 Low Input Voltage Shutdown', answer: 'This means the unit has detected the input from the Solar Array cannot sustain voltage above 14.5v.If you have this error:• Check that you are not in a low light/non direct sunlight situation i.e. Early morning / late afternoon.• This may also happen if your solar panels are inside in a shed with a skylight or Hi Bay Lights running or outside underFlood Lights.If you find this is happening with your unit when stored, we recommend fitting a DC Breaker to the output of the DC2DC+and turning it off when the unit is not in use/storage.' },
        { key: 'E05', id: 'bit0', question: 'CH1 High Input Voltage Shutdown', answer: 'This means the unit has detected that the Main/House battery has gone above 16.0V. This error will clear once the input has dropped below 15.5V. This may be due to charging from another source. i.e. Another solar controller or AC battery charger.' },
        { key: 'E06', id: 'bit5', question: 'Over Temperature Shutdown', answer: 'Over Temperature Shutdown When the charger senses the environmental temperature above 60°C, the charger will Shut down. It will recover automatically when the environmental temperature drops below 45°C.• Check to make sure the fan is working.• Make sure the unit has good ventilation.' },
        { key: 'E07', id: '', question: 'BTS Over Temperature Shutdown', answer: 'This means the units Battery Temp Sensor has detected that the batteries are too hot and has shut down to not over charge the batteries. If this occurs, take care and check the temperature of the batteries. • If the Batteries are Hot –you may have a dropped cell or faulty battery. Stop all charging and see your local battery shop to get your batteries tested. • If the Batteries/Terminals are still cool or only warm, you may have a bad temp sensor. Unplug the temp sensor and call Enerdrive.' },
        { key: 'E08', id: 'bit7', question: 'CH1 Output Short Circuit', answer: 'This means there is a Short Circuit on the DC output to your Main/House battery. If this is displayed, check the following: • The output wires are not shorted together. • The output wires are wired correctly and not reverse polarity.' },
        { key: 'A01', id: '', question: 'Over Temperature Warning', answer: 'When the charger’s internal temperature is > 60°C, the unit will shut down to protect itself. The unit will return back to normal charging once the internal temperature is < 58°C • Check to make sure the fan is working. • Make sure the unit has good ventilation.' },
        { key: 'A02', id: '', question: 'BTS High Temperature Warning', answer: 'When the battery temperature sensor is > 58°C, the unit will shut down to protect the batteries. The unit will return back to normal charging once the battery temperature sensor is < 56°C.• Check to make sure the batteries are not hot.• Make sure the batteries have good ventilation.' }
      ],
      timer: null

    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    dcTabPaneInfo: {
      handler(newValue, oldValue) {
        this.MQTT()
      },
      deep: true,
      immediate: true
    },
    dcInfoTem: {
      handler(newValue, oldValue) {
        this.dcInfoTem = newValue // 把新值赋值给我们的属性数据
      },
      deep: true,
      immediate: true
    },
    language(newValue, oldValue) {
      if (this.dcInfoTem.timeAgoRes) this.dcInfoTem.timeAgo = updateTimeOnlyEn(this.dcInfoTem.timeAgoRes)
    }
  },
  mounted() {
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    MQTT() {
      console.log('mqtt**dcTem********', this.dcTabPaneInfo)
      if (this.dcTabPaneInfo.dataFrom == 'api') {
        this.dcInfoTem.timeAgoRes = this.dcTabPaneInfo.timeAgoRes
        this.dcInfoTem.timeAgo = updateTimeOnlyEn(this.dcInfoTem.timeAgoRes)
        this.dcInfoTem.online = false
      } else if (this.dcTabPaneInfo.dataFrom == 'mqtt') {
        if (!this.dcTabPaneInfo) return
        this.dcInfoTem.timeAgo = 'A Moment Ago'
        this.dcInfoTem.timeAgoRes = new Date().getTime()
        if (this.dcTabPaneInfo.connection === 1) { // 设备状态 1：连接 0：断开
          this.dcInfoTem.online = true
        } else {
          this.dcInfoTem.online = false
        }
        // if (this.dcInfoTem.tcId == this.dcTabPaneInfo.tc_ID) {

        if (this.dcTabPaneInfo.machineModel) this.dcInfoTem.dcBatteryType = this.dcTabPaneInfo.machineModel.toString(16)
        // 太阳能板和电源都连接的情况下，优先使用太阳能
        if (this.dcTabPaneInfo.pvInput_V) {
          this.dcInfoTem.curBy = 'pv'
          this.dcInfoTem.pvV = (this.dcTabPaneInfo.pvInput_V / 100).toFixed(2)
          this.dcInfoTem.pvA = (this.dcTabPaneInfo.input_I / 100).toFixed(2)
        } else if (this.dcTabPaneInfo.batInput_V) {
          this.dcInfoTem.curBy = 'alt'
          this.dcInfoTem.altV = (this.dcTabPaneInfo.batInput_V / 100).toFixed(2)
          this.dcInfoTem.altA = (this.dcTabPaneInfo.input_I / 100).toFixed(2)
        } else if (this.dcTabPaneInfo.output_V) { // pvInput_V和batInput_V都不存在，但output_V存在，代表充满电了

        }
        this.dcInfoTem.status = this.dcTabPaneInfo.chargeStage
        this.dcInfoTem.outV = (this.dcTabPaneInfo.output_V / 100).toFixed(2)
        this.dcInfoTem.outA = (this.dcTabPaneInfo.output_I / 100).toFixed(2)
        // this.dcTabPaneInfo.errorCode = 3// 假数据
        // 警告
        var errors = []
        this.warningList = []
        if (this.dcTabPaneInfo.errorCode) { // 警告
          errors = this.decimalToBinary(this.dcTabPaneInfo.errorCode, '2')
          var errorsInfoArr = []
          // 如：this.dcTabPaneInfo.errorCode=3，errors=[1, 1, 0, 0, 0, 0, 0, 0]，errorsInfoArr= ["bit0", "bit1", "bit-2", "bit-3", "bit-4", "bit-5", "bit-6", "bit-7"]
          errors.forEach((v, i) => {
            if (v == 1) {
              errorsInfoArr.push('bit' + i)
            } else {
              errorsInfoArr.push('bit-' + i)
            }
          })
          errorsInfoArr.forEach(v => {
            this.warningdcInfo.forEach(m => {
              if (v == m.id) {
                this.warningList.push({
                  imgUrl: require('@/assets/images/warningSimpleImg/' + m.key + '.png'),
                  question: m.question,
                  answer: m.answer
                })
              }
            })
          })
        }
        if (!this.dcInfoTem.online) {
          for (var k in this.dcInfoTem) {
            if (k != 'online') {
              this.dcInfoTem[k] = '--'
              this.warningList = []
            }
          }
        }
      }
      // this.dcInfoTem.online = this.dcInfoTem.online
      // this.dcInfoTem.MqttOnline = this.dcInfoTem.online
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.dcInfoTem.timeAgoRes) this.dcInfoTem.timeAgo = updateTimeOnlyEn(this.dcInfoTem.timeAgoRes)
        }, 60000)
      }
    },
    decimalToBinary(num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    }
  }
}
</script>
<style lang="scss">
#dcDetail{
  .altData{
    // left: calc(10% - 48px);
    // left:-50px;
    // top: 9%;
    left: calc(5% - 40px);
    top: 27%;
    text-align: center;
  }
  .pvData{
    left: calc(49% - 40px);
    top: 99.4%;
  }
  .outData{
    left: calc(92.8% - 40px);
    top: 27.8%;
  }
}
</style>

